export const PIECE = 'piece'
export const HOUR = 'hour'
export const KM = 'km'
